// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1zj57","options":"style_options__3iksY","title":"style_title___UbQN","content":"style_content__2GlE0","list":"style_list__sePmY"};